import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useCookies } from 'react-cookie';
import { Row, Col, Card, Container } from 'reactstrap';
import classNames from 'classnames';
import { Image } from '@bottomless/common/components';
import { QuizHeader } from './QuizHeader';
import { QuestionText } from './QuestionText';

const coffeeCupIcon = 'https://bottomless.imgix.net/assets/q5-simple-coffee-icon.png';

const answers = [
  {
    name: '1 cup',
    size: '12 oz',
    value: 'size:12;displayCups:1',
    icon: coffeeCupIcon,
  },
  {
    name: '2 cups',
    size: '12 oz',
    value: 'size:12;displayCups:2',
    icon: coffeeCupIcon,
  },
  {
    name: '3 cups',
    size: '32 oz',
    value: 'size:32;displayCups:3',
    icon: coffeeCupIcon,
  },
  {
    name: '4 cups',
    size: '32 oz',
    value: 'size:32;displayCups:4',
    icon: coffeeCupIcon,
  },
];

export const Question5 = ({ index, total, displayIndex, displayTotal, onAnswer, answers: quizAnswers, isMobile }) => {
  const [{ gift }] = useCookies(['gift']);

  const filteredAnswers = useMemo(() => (gift ? answers.filter(answer => answer.value.includes('size:12')) : answers), [
    gift,
  ]);

  return (
    <>
      <QuizHeader
        index={displayIndex}
        total={displayTotal}
        quizAnswers={quizAnswers}
        description="Just an estimate; we'll get to know your habits."
      />
      <QuestionText
        index={index - 1}
        total={total - 1}
        title="Bag Size"
        subtitle="How much coffee does your household go through in a day?"
      />
      <Container className="mt-4 px-0">
        <Row className="justify-content-center quiz-answer-row">
          {filteredAnswers.map((answer, i) => (
            <Col key={i} xs="12" sm="6" lg="3" className="quiz-answer-col">
              <Card
                body
                tag="button"
                className={classNames(
                  'd-flex flex-md-row flex-column align-items-center justify-content-center w-100 answer',
                  {
                    'answer-selected': quizAnswers?.[index] === answer.value,
                  }
                )}
                onClick={() => onAnswer(answer)}
              >
                {quizAnswers?.[index] === answer.value && <span className="quiz-answer-check">✓</span>}
                <Image
                  wrapperClassName="quiz-bag-size-icon"
                  src={answer.icon}
                  width={56}
                  alt={`Answer - ${answer.name}`}
                  useSrcset
                />
                <p
                  className={classNames('mb-0 text-left', {
                    'ml-4': !isMobile,
                    'mt-2': isMobile,
                  })}
                >
                  {answer.name}
                  <span className="d-block text-secondary quiz-answer-size">{answer.size}</span>
                </p>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </>
  );
};

Question5.propTypes = {
  index: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  displayIndex: PropTypes.number.isRequired,
  displayTotal: PropTypes.number.isRequired,
  onAnswer: PropTypes.func.isRequired,
  answers: PropTypes.object,
  isMobile: PropTypes.bool.isRequired,
};

Question5.sizeRelated = true;
